export enum StockSelectReportType {
  delivery = 'Delivery',
  return = 'Return',
  employeesVsInputs = 'EmployeePerConsumable',
}

export enum StockFilterByDate {
  closing = 'Closing',
  deliveryReturn = 'DeliveryReturn',
}

export enum StockGroupReportBy {
  date = 'Date',
  employee = 'Employee',
}

export enum StockType {
  stockist = 'Stockist',
  employee = 'Employee',
}

export interface DeliveryOfMaterialDateType {
  startDate: string;
  endDate: string;
  companiesIds?: string;
}

export interface DeliveryOfMaterialFormValues {
  reportType: StockSelectReportType;
  employeePerConsumableReportType?: StockFilterByDate;
  employeePerConsumableGroupBy: StockGroupReportBy;
  showEmployee?: boolean;
  type: StockType;
  osFilter?: number;
  employeesIds?: string;
}
